import React from "react";
import { Button, Upload } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { useTeamModel } from "../teamModel";
import { globalPrompt } from "@/components/message";
import { IMD5ImgField } from "../teamTypes"
export const DataBox = () => {
    const { selectedRowKeys,
        selectedRow,
        md5List,
        setIVisibleDrawer,
        onRemove,
        setMd5FormVal,
        setMd5List
    } = useTeamModel();
    const onAdd = () => {
        setIVisibleDrawer("add")
    }
    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑", type: "warning" });
            return;
        }
        let { list } = selectedRow[0] as { list: IMD5ImgField[] }
        setMd5FormVal(list ? list.map(item=>item.imgMd5) as string[]: [])
        setMd5List(list)
        setIVisibleDrawer("edit")
    }
    const onDelete = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑", type: "warning" });
            return;
        }
        onRemove(selectedRowKeys[0])
    }
    const action = <>

        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onAdd}
        >新增</Button>

        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onEdit}
        >编辑</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onDelete}
        >删除</Button>
    </>

    return (
        <YhBox title="公司荣誉列表" action={action}>
            <DataTable />
        </YhBox>
    )
}
